/** Clés JSON Schema à ne jamais traiter comme champs métier. */
export const SCHEMA_META_KEYS = new Set(["type", "properties"]);

export function looksLikeJsonSchema(schema) {
    return Boolean(
        schema && typeof schema === "object" && !Array.isArray(schema)
        && schema.type === "object" && schema.properties && typeof schema.properties === "object",
    );
}

export function looksLikeManualMap(schema) {
    if (!schema || typeof schema !== "object" || Array.isArray(schema)) return false;
    const keys = Object.keys(schema).filter((k) => !SCHEMA_META_KEYS.has(k));
    if (keys.length === 0) return false;
    return keys.every((k) => {
        const v = schema[k];
        return v && typeof v === "object" && !Array.isArray(v) && ("type" in v || "description" in v);
    });
}

export function filterSchemaMetaKeys(map) {
    const out = {};
    Object.entries(map || {}).forEach(([k, v]) => {
        if (!SCHEMA_META_KEYS.has(k)) out[k] = v;
    });
    return out;
}

/**
 * Source unique éditeur : payload_fields_manual (API) ou extraction depuis payload_schema.
 */
export function extractPayloadFieldsManual(detail) {
    if (!detail || typeof detail !== "object") return {};

    if (detail.payload_fields_manual && typeof detail.payload_fields_manual === "object") {
        return filterSchemaMetaKeys(detail.payload_fields_manual);
    }

    const schema = detail.payload_schema;
    if (!schema || typeof schema !== "object") return {};

    if (detail.payload_schema_format === "manual_map" || looksLikeManualMap(schema)) {
        return filterSchemaMetaKeys(schema);
    }
    if (looksLikeJsonSchema(schema)) {
        return filterSchemaMetaKeys(schema.properties);
    }
    return filterSchemaMetaKeys(schema);
}

export function manualMapToFormFields(manualMap) {
    return Object.entries(manualMap || {}).map(([key, val]) => ({
        id: `${key}_${Math.random().toString(36).slice(2, 9)}`,
        key,
        type: val?.type || "string",
        description: val?.description || "",
    }));
}

export function formFieldsToManualMap(fields) {
    const out = {};
    (fields || []).forEach((f) => {
        const key = f.key?.trim();
        if (!key) return;
        out[key] = {
            type: f.type || "string",
            ...(f.description?.trim() ? { description: f.description.trim() } : {}),
        };
    });
    return out;
}

export function hasPayloadFieldsManual(detail) {
    return Object.keys(extractPayloadFieldsManual(detail)).length > 0;
}

export function resolvePayloadSchemaFormat(detail) {
    if (detail?.payload_schema_format) return detail.payload_schema_format;
    const manual = extractPayloadFieldsManual(detail);
    if (Object.keys(manual).length === 0 && !detail?.payload_schema) return null;
    if (looksLikeJsonSchema(detail?.payload_schema)) return "json_schema";
    return "manual_map";
}
